/**
 * Symbole temporaire de Gestion.
 *
 * Trois barres décalées dans un carré en gradient : une onde, un niveau,
 * un flux. Cela évoque le son et la circulation de données sans être un
 * logo de club, et cela tient à 12 px comme à 44 px.
 *
 * ⚠ Placeholder de prototype. Il ne deviendra pas le logo définitif — il
 * existe pour qu'on puisse juger l'ensemble avec quelque chose de crédible
 * à la place d'une pastille.
 */
export function Mark({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3"  y="9"  width="3.4" height="6"  rx="1.7" fill="currentColor" opacity=".62" />
      <rect x="8.6" y="4.5" width="3.4" height="15" rx="1.7" fill="currentColor" />
      <rect x="14.2" y="7"  width="3.4" height="10" rx="1.7" fill="currentColor" opacity=".82" />
      <rect x="19.8" y="10.5" width="1.6" height="3"  rx=".8" fill="currentColor" opacity=".45" />
    </svg>
  )
}

/** Variante « onde » pour la carte de pied de la barre latérale. */
export function Waveform({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      {[
        { x: 2,  h: 8 },  { x: 6,  h: 16 }, { x: 10, h: 22 },
        { x: 14, h: 12 }, { x: 18, h: 20 }, { x: 22, h: 10 }, { x: 26, h: 6 },
      ].map((b, i) => (
        <rect
          key={b.x}
          x={b.x - 1} y={14 - b.h / 2} width="2" height={b.h} rx="1"
          fill="currentColor" opacity={0.45 + (i % 3) * 0.22}
        />
      ))}
    </svg>
  )
}
